var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8167 52.1212C85.8167 48.464 83.0579 45.7693 79.6574 45.7693C76.8985 45.7693 74.5887 47.4375 73.6263 49.7472L70.5466 56.4841C70.3541 56.4841 61.2432 53.5969 50.9133 53.5969C40.5835 53.5969 31.0877 56.4841 30.8953 56.6766L28.1364 50.3247C27.2382 47.5658 24.8642 45.7693 21.9769 45.7693C18.5123 45.7693 15.625 48.5282 15.625 52.1212C15.625 55.0084 17.614 57.3824 20.3729 58.1523L21.6561 68.1613C22.7468 72.5243 28.9063 72.7168 28.9063 72.7168H72.728C72.728 72.7168 78.7591 72.5243 79.9781 68.1613L81.2614 58.1523C83.8278 57.3824 85.8167 55.0084 85.8167 52.1212Z",
    fill: "#39B980"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9768 41.2138C26.1472 41.2138 29.9968 43.9727 31.28 47.9506L32.5632 50.8379C35.3221 49.9396 44.9462 49.0414 50.9132 49.0414C56.9443 49.0414 66.3759 49.9396 69.0706 50.8379L70.5464 47.3732C72.0221 43.5236 75.6151 41.2138 79.6572 41.2138C79.8497 41.2138 80.2347 41.2138 80.363 41.2138C80.363 33.9636 74.5243 28.125 67.2742 28.125H34.3597C27.1096 28.125 21.271 33.9636 21.271 41.2138C21.4635 41.2138 21.7843 41.2138 21.9768 41.2138Z",
    fill: "#39B980"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.b18eef2a600eacf54b4f9dea6a8bbe06.svg";
export { ForwardRef as ReactComponent };